import { Field, Form, Formik, FormikHelpers } from 'formik';
import FormInput from '../shared/forms/input';
import Button from '../shared/buttons/button';
import { useCreateTempUserMutation } from '../../hooks/react-query/use-temp-user';
import { CreateTempUserDataType } from '../../api/temp-user';
import { useState } from 'react';
import WebinarModal, { AUTH_STATE } from './modals/modal';
import { randomString } from '../../utils/random';
import { useFormErrorMessage } from '../../hooks/index/use-form-error-message';
import Alert from '../shared/alert';
import { useUser } from '../../hooks/react-query/use-user';
import { mobile } from '../shared/forms/validations';
import Loader from '../shared/loader';
import { useNavigate } from 'react-router-dom';

export type WebinarFormData = CreateTempUserDataType;
export type WebinarFormPropsType = {
  formId?: string;
};

function WebinarForm({ formId = randomString(5) }: WebinarFormPropsType) {
  const [showModal, setShowModal] = useState(false);
  const [modalState, setModalState] = useState<AUTH_STATE>('DONE');
  const { mutate: createTempUser } = useCreateTempUserMutation();
  const { formErrorMessage, resetFormErrorMessage } = useFormErrorMessage();
  const { data: user, isLoading: userIsLoading, isAuthenticated } = useUser();
  const navigate = useNavigate();

  async function submit(values: WebinarFormData, { setErrors }: FormikHelpers<WebinarFormData>) {
    resetFormErrorMessage();
    if (isAuthenticated) {
      navigate('/store');
    } else {
      createTempUser(values, {
        onSuccess: () => {
          setModalState('REGISTER');
          setShowModal(true);
        },
        onError: error => {
          if (
            error.status === 400 &&
            error.data[0] === 'کاربری با این شماره تلفن همراه وجود دارد.'
          ) {
            setModalState('LOGIN');
            setShowModal(true);
          } else {
            setErrors({ mobile: error.data });
          }
        }
      });
    }
  }

  if (userIsLoading) return <Loader full={false} />;

  return (
    <Formik initialValues={{ mobile: user?.mobile || '' }} onSubmit={submit}>
      {({ values, dirty, isSubmitting }) => (
        <>
          <Form noValidate className='grid grid-cols-1 gap-2 py-3'>
            {formErrorMessage && <Alert content={formErrorMessage} className='my-2' />}
            {!isAuthenticated && (
              <Field
                required
                noLabel
                id={`${formId}_mobile`}
                name='mobile'
                placeholder='شماره تلفن همراه'
                component={FormInput}
                type='tel'
                maxLength={11}
                validate={mobile}
              />
            )}
            <Button
              type='submit'
              color='green'
              content='ثبت‌نام با تخفیف'
              disabled={!dirty && isSubmitting}
              className='2xs:text-lg'
            />
          </Form>
          <WebinarModal
            state={modalState}
            showModal={showModal}
            mobile={values.mobile}
            onSuccess={() => {
              setShowModal(false);
              navigate('/store?type=4&package=1');
            }}
            onClose={() => setShowModal(false)}
          />
        </>
      )}
    </Formik>
  );
}

export default WebinarForm;
